module.exports = __webpack_public_path__ + "c68ff961baf04c04f9beac2c32cd2458.svg";